/**
 * Releases the navigation an editor's unsaved-changes guard parked (`setNextCallbackFunction`), once the editor has
 * its answer — clean, Discard, or a finished Save & close. Returns whether there was one to release.
 *
 * <b>Taken out of the store before it runs (KOA-18653).</b> The navigation usually mounts the next editor, and every
 * editor watches this same slot in `componentDidUpdate`. Run first and cleared second, the next editor saw a navigation
 * still pending before its own unsaved-changes baseline existed, took itself for dirty and raised a second "Unsaved
 * Changes" prompt over an editor nobody had touched. Clearing second also wiped out a navigation the released one
 * parked in turn. Every editor releases through here, so the order cannot drift per copy again.
 */
export const runParkedNavigation = (
  nextCallback: (() => void) | undefined,
  setNextCallbackFunction: ((cb?: () => void) => void) | undefined
): boolean => {
  if (!nextCallback) return false;
  setNextCallbackFunction?.();
  nextCallback();
  return true;
};
